import { useContext, useState } from 'react';
import { Grid2 as Grid, Typography, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Link, Paper} from '@mui/material';
import { FilersDataContext } from '../../Filers';
import FilerDocument from '../../../../types/filers/filerDocument';
import DocumentViewer from '../DocumentViewer/DocumentViewer';


const FilerDocuments = (): JSX.Element => {

    const filerDataContext = useContext(FilersDataContext);
    const filerDocuments = filerDataContext.currentFilerDocuments;

    const [isDocumentViewerOpen, setDocumentViewerOpen] = useState(false);
    const [selectDocument, setSelecteDocument] = useState<FilerDocument>();
    
    const openDocumentViewer = (document: FilerDocument) => {
        setDocumentViewerOpen(true);
        setSelecteDocument(document);
      };
    
      const closeDocumentViewer = () => {
        setDocumentViewerOpen(false);
        setSelecteDocument(undefined);   
      };

    return (
        <Grid container marginBottom={2}>
            <Grid size={{xs:12, md:11, lg:10}}>
            {
                (filerDocuments ?? []).length > 0 &&
                <TableContainer component={Paper}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell><Typography variant='subtitle2' fontWeight={600}>Date</Typography></TableCell>
                                <TableCell><Typography variant='subtitle2' fontWeight={600}>Letter Type</Typography></TableCell>
                                <TableCell><Typography variant='subtitle2' fontWeight={600}>View</Typography></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {
                            filerDocuments?.map((document) =>
                                <TableRow key={document.id}>
                                    <TableCell>
                                       <Typography variant="body2">{document.documentDateDisplay}</Typography> 
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2">{document.documentTypePublicDescription}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Link>
                                            <Typography className="is-clickable" variant="body2" fontWeight={520} onClick={()=>openDocumentViewer(document)}>
                                                {document.documentTypeCode}
                                            </Typography>
                                        </Link>
                                    </TableCell>
                                </TableRow>
                            )
                        }
                        </TableBody>
                    </Table>
                </TableContainer>
            }
            </Grid>
            <DocumentViewer isDocumentViewerOpen={isDocumentViewerOpen} closeDocumentViewer={closeDocumentViewer} document={selectDocument}></DocumentViewer>
        </Grid>
    );
  };

export default FilerDocuments;